import ChildBook from '@/models/ChildBook'
import { callApi } from '@/_core/api/apiWrapper'

export const getChildBook = async (childId, bookId) => {
  if (!childId || !bookId) return
  const response = await callApi({
    method: 'get',
    url: `books/${childId}/${bookId}/`
  })
  if (response.data) response.data = new ChildBook(response.data)
  return response
}
